import React from 'react';
import { connect } from 'react-redux';
import { compose } from '../actions';
import { loadNews } from '../actions/news.actions';

import WelcomeBanner from '../components/WelcomeBanner';
import SectionTitle from '../components/SectionTitle';
import NewsElement from '../components/News/NewsElement';
import RightSidebar from '../components/RightSidebar/RightSidebar';

import './stylings/News.css';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner.component';


export class News extends React.Component {
	componentDidMount() {
		this.props.loadNews();
	}

	renderNewsItems() {
		let itemIsRightAligned = false;
		let items = [];

		for (let item of this.props.newsData) {
			let stylingClasses = itemIsRightAligned ?
				'col-xlarge-5' : 'col-xlarge-5 xlarge-pull-right';

			items.push(
				<NewsElement
					key={item.title.rendered}
					title={item.title.rendered} 
					author={item.acf.author} 
					imageOrientation={stylingClasses} 
					imageSrc={item.acf.image}
					date={item.date} 
					newsContent={item.acf.text} />
			);

			itemIsRightAligned = !itemIsRightAligned;
		}

		return items;
	}

	renderContent() {
		const newsItems = this.renderNewsItems();

		return (
			<div className="container">
				<SectionTitle title="Neues" />
				<div className="clearfix">
					<div className="col-xlarge-8 col-medium-8">
						<div className="section-inner no-border">
							<ul className="block-list-2">
								{newsItems}								
							</ul>
						</div>
					</div>
					<div className="col-xlarge-4 col-medium-4">
						<RightSidebar />
					</div>
				</div>
			</div>
		);
	}


	render() {
		let renderedContent = this.renderContent();

		if (this.props.isLoading) {
			renderedContent = <LoadingSpinner />
		} else {
			renderedContent = this.renderContent();
		}

		return (
			<div className="animated fadeIn">
				<WelcomeBanner />
				<section className="image-block-section">
					{renderedContent}
				</section>
			</div>
		);
	}
}


const mapStateToProps = ({news}) => {
	return {
		newsData: news.get('newsData'),
		isLoading: news.get('isLoading')
	};
};

const mapDispatchToProps = dispatch => ({
	loadNews: compose(dispatch, loadNews)
});

export default connect(mapStateToProps, mapDispatchToProps)(News);


// WEBPACK FOOTER //
// ./src/containers/News.js